<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar rounede dense class="white--text" color="indigo" flat>
        <v-toolbar-title>Tempi di Fermo</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Input della data da -->
        <v-menu
          v-model="calendario_data_da"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data Da"
                v-model="data_da_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_da"
            @input="calendario_data_da = false"
          ></v-date-picker>
        </v-menu>

        <!-- Input della data a -->
        <v-menu
          v-model="calendario_data_a"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data A"
                v-model="data_a_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_a"
            @input="calendario_data_a = false"
          ></v-date-picker>
        </v-menu>

        <!-- Bottone della ricerca -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="getCommessaCausali"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Cerca</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickAggiungiFermi" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-btn
          class="red--text"
          @click="clickChiudi"
          color="blue-grey lighten-5"
          small
        >
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_fermo_totali"
              item-text="cod_commessa"
              item-value="cod_commessa"
              label="Cod Commessa"
              style="display: inline-block; max-width: 350px"
              v-model="cod_commessa_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_causali_fermo_totali.filter(
                  (e) => e.cod_macchina != null && e.cod_macchina != ''
                )
              "
              item-text="cod_macchina"
              item-value="cod_macchina"
              label="Cod. Macchina"
              style="display: inline-block; max-width: 350px"
              v-model="cod_macchina_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_macchina_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_macchina_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_fermo_totali"
              item-text="nominativo"
              item-value="nominativo"
              label="Nome Operatore"
              style="display: inline-block; max-width: 350px"
              v-model="nome_operatore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    nome_operatore_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    nome_operatore_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_causali_fermo_totali.filter((e) => e.date_ins != null)
              "
              item-text="date_ins_corta"
              item-value="date_ins_corta"
              label="Data"
              style="display: inline-block; max-width: 350px"
              v-model="dalla_data"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    dalla_data = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    dalla_data == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_causali_fermo_totali.filter((e) => e.minuti != null)
              "
              item-text="minuti"
              item-value="minuti"
              label="Quantità"
              style="display: inline-block; max-width: 350px"
              v-model="quantita_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    quantita_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    quantita_search == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_fermo_totali.filter((e) => e.causale != '')"
              item-text="causale"
              item-value="id_causale"
              label="Causale"
              style="display: inline-block; max-width: 350px"
              v-model="causale_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    causale_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    causale_search == null ? "mdi-filter" : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-data-table
          class="elevation-1"
          :headers="header_causali_fermo"
          height="70vh"
          :items="items_causali_fermo"
        >
          <!-- Bottone di modifica delle dichiarazioni -->
          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickModificaRiga(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica Dichiarazione</span>
            </v-tooltip>
          </template>

          <!-- Colonna della data -->
          <template v-slot:[`item.date_ins`]="{ item }">
            {{
              item.date_ins != null &&
              item.date_ins != undefined &&
              item.date_ins != ""
                ? item.date_ins
                : "N/D"
            }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="rettifica_dialog" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Rettifica Fermo
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRettifica" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiRettificaDialog"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="6" align="center">
              <v-text-field
                dense
                hide-details
                label="Minuti"
                style="max-width: 150px"
                type="number"
                v-model="riga_sel.minuti"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                dense
                hide-details
                :items="items_causali"
                item-text="des"
                item-value="id_tabella"
                label="Causale"
                v-model="riga_sel.id_causale"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga pezzi -->
    <v-dialog v-model="dialog_aggiungi_fermi" persistent width="unset">
      <v-card style="max-width: 900px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Riga Fermi
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="clickSelezionaTempi"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Ricerca Tempi</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRigaFermi" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Riga</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_aggiungi_fermi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Start"
                  readonly
                  v-model="start_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Stop"
                  readonly
                  v-model="stop_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Commessa"
                  v-model="cod_commessa_tmp"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Fase"
                  v-model="cod_fase_tmp"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Minuti"
                  v-model.number="minuti_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_causali"
                  item-text="des"
                  item-value="id_tabella"
                  label="Causale"
                  v-model="id_causale_tmp"
                >
                </v-autocomplete>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_tipo_causali"
                  item-text="des"
                  item-value="id_tabella"
                  label="Tipo"
                  v-model="tipo_tmp"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="tipo_tmp = null"
                      color="error"
                      v-if="tipo_tmp != null"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione del tempo di produzione -->
    <v-dialog v-model="dialog_seleziona_tempi" width="unset">
      <v-card style="max-width: 800px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Tempo di Produzione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_tempi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_da"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data Da"
                      v-model="tempi_data_da_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_da"
                    @input="calendario_tempi_data_da = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_a"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data A"
                      v-model="tempi_data_a_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_a"
                    @input="calendario_tempi_data_a = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getTempi" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Ricerca Tempi</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_tempi_selezionabili"
                  :items="items_tempi_selezionabili"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaTempo(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.ora_inizio`]="{ item }">
                    {{ formatData(item.ora_inizio, "full") }}
                  </template>

                  <template v-slot:[`item.ora_fine`]="{ item }">
                    {{ formatData(item.ora_fine, "full") }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Loader -->
      <v-overlay :value="caricamento_dati">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Riga {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "causale", default_val: "" },
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "cod_macchina", default_val: "" },
      { nome: "date_ins", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "minuti", default_val: 0 },
      { nome: "tipo_causale", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "TabellaFermi",
  components: { SnackbarQV },
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    dalla_data_search() {
      return this.dalla_data
        ? moment(
            `${this.dalla_data.substr(6, 4)}-${this.dalla_data.substr(
              3,
              2
            )}-${this.dalla_data.substr(0, 2)}`
          )
        : null;
    },
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
    start_tmp_formattato() {
      return this.start_tmp != ""
        ? moment(this.start_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    stop_tmp_formattato() {
      return this.stop_tmp != ""
        ? moment(this.stop_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    tempi_data_a_formattata() {
      return this.tempi_data_a != ""
        ? moment(this.tempi_data_a).format("DD/MM/YYYY")
        : "";
    },
    tempi_data_da_formattata() {
      return this.tempi_data_da != ""
        ? moment(this.tempi_data_da).format("DD/MM/YYYY")
        : "";
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      causale_search: null,
      cod_commessa_search: null,
      cod_commessa_tmp: "",
      cod_fase_tmp: "",
      cod_macchina_search: null,
      dalla_data: null,
      data_a: null,
      data_da: null,
      id_causale_tmp: null,
      id_commessa_tmp: null,
      id_commessa_dettaglio_tmp: null,
      id_commessa_tempi_tmp: null,
      limite_mesi_passati: 0,
      minuti_tmp: null,
      nome_operatore_search: null,
      quantita_search: null,
      riga_sel: new Riga(),
      start_tmp: "",
      stop_tmp: "",
      tempi_data_a: "",
      tempi_data_da: "",
      tipo_tmp: null,

      // Modal
      calendario_data_a: false,
      calendario_data_da: false,
      calendario_tempi_data_a: false,
      calendario_tempi_data_da: false,
      caricamento_dati: false,
      dialog_aggiungi_fermi: false,
      dialog_seleziona_tempi: false,
      rettifica_dialog: false,

      // Array
      header_causali_fermo: [
        { text: "Modifica", value: "modifica", sortable: false },
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        { text: "Cod. Fase", value: "cod_fase", sortable: false },
        { text: "Des. Fase", value: "des_fase", sortable: false },
        { text: "Cod. Macchina", value: "cod_macchina", sortable: false },
        { text: "Data", value: "date_ins", sortable: false },
        { text: "Nominativo", value: "nominativo", sortable: false },
        { text: "Causale", value: "causale", sortable: false },
        { text: "Minuti", value: "minuti", sortable: false },
      ],
      headers_tempi_selezionabili: [
        {
          text: "Selezione",
          sortable: false,
          value: "selezione",
        },
        {
          text: "Start",
          sortable: false,
          value: "ora_inizio",
        },
        {
          text: "Stop",
          sortable: false,
          value: "ora_fine",
        },
        {
          text: "Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Fase",
          sortable: false,
          value: "cod_fase",
        },
      ],
      items_causali: new Array(),
      items_tipo_causali: new Array(),
      items_causali_fermo: new Array(),
      items_causali_fermo_totali: new Array(),
      items_tempi_selezionabili: new Array(),
    };
  },
  methods: {
    checkModificaConsentita(arg) {
      /* Se il limite dei mesi passati è 0 vuol dire che
       * non l'ho impostato, quindi ritorno sempre true. */
      if (this.limite_mesi_passati == 0) {
        return true;
      }

      let data = moment(arg);
      let terminus_ante_quem = moment(
        `${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("YYYY")
        )}-${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("M")
        )}-01`
      );

      /* Ritorno true solo se la data passata è successiva
       * ad "adesso" meno il limite temporale consentito. */
      return data.isSameOrAfter(terminus_ante_quem);
    },
    chiudiRettificaDialog() {
      this.rettifica_dialog = false;
    },
    clickAggiungiFermi() {
      this.dialog_aggiungi_fermi = true;
      this.id_commessa_tmp = null;
      this.cod_commessa_tmp = "";
      this.id_commessa_dettaglio = null;
      this.cod_fase_tmp = "";
      this.quantita_tmp = null;
      this.id_causale_tmp = null;
      this.tipo_tmp = null;
      this.start_tmp = "";
      this.stop_tmp = "";
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickModificaRiga(arg) {
      let is_modifica_consentita = this.checkModificaConsentita(
        `${arg.date_ins_corta.split("/")[2]}-${
          arg.date_ins_corta.split("/")[1]
        }-01`
      );

      if (!is_modifica_consentita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è consentito modificare record così vecchi: il limite è ${
            this.limite_mesi_passati
          } ${this.limite_mesi_passati == 1 ? "mese" : "mesi"}.`
        );
        return;
      }

      this.riga_sel = new Riga(arg);
      this.rettifica_dialog = true;
    },
    clickSelezionaTempi() {
      this.dialog_seleziona_tempi = true;
    },
    filtra() {
      let items_fermo_tmp = [];
      this.items_causali_fermo_totali.forEach((elem) => {
        items_fermo_tmp.push(elem);
      });

      //Filtro il codice Commessa
      if (this.cod_commessa_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.cod_commessa == this.cod_commessa_search) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      // Filtro il codice macchina
      if (this.cod_macchina_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.cod_macchina == this.cod_macchina_search) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      // Filtro il nome dell'operatore
      if (this.nome_operatore_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.nominativo == this.nome_operatore_search) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      // Filtro la data_da
      if (this.dalla_data_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.data_js.isSame(this.dalla_data_search)) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      // Filtro la quantita
      if (this.quantita_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.minuti == this.quantita_search) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      // Filtro la causale
      if (this.causale_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_fermo_tmp.forEach((elem) => {
          if (elem.id_causale == this.causale_search) {
            res.push(elem);
          }
        });
        items_fermo_tmp = res;
      }

      this.items_causali_fermo = [];
      this.items_causali_fermo = items_fermo_tmp;
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getCommessaCausali() {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessacausali",
          token: localStorage.user_token,
          tipo: "FERMO",
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_causali_fermo = new Array();
            res.data.result.commessa_causali.forEach((e) => {
              const riga_tmp = new Riga(e);

              /* Mi faccio una data javascript per riuscire
               * a filtrare gli oggetti in base alla data. */
              riga_tmp.data_js = moment(`${e.date_ins.substr(
                0,
                4
              )}-${e.date_ins.substr(5, 2)}-${e.date_ins.substr(8, 2)}
              `);

              // Formatto come Dio comanda la data umana degli oggetti.
              riga_tmp.date_ins = `${e.date_ins.substr(
                8,
                2
              )}/${e.date_ins.substr(5, 2)}/${e.date_ins.substr(
                0,
                4
              )} ${e.date_ins.substr(11, 8)}
              `;

              // Mi faccio un campo per i valori della autocomplete di filtro.
              riga_tmp.date_ins_corta = `${e.date_ins.substr(
                8,
                2
              )}/${e.date_ins.substr(5, 2)}/${e.date_ins.substr(0, 4)}`;

              // Metto negli oggetti la descrizione della causale.
              this.items_causali.forEach((c) => {
                if (c.id_tabella == riga_tmp.id_causale) {
                  riga_tmp.causale = c.des;
                }
              });

              // Aggiungo l'oggetto agli array su cui lavorerà il FE.
              this.items_causali_fermo.push(Object.assign({}, riga_tmp));
              this.items_causali_fermo_totali.push(Object.assign({}, riga_tmp));
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTabella() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "'FASE_causali','TIPO_CAUSALE_FERMO'",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.items_causali = res.data.FASE_causali
                ? res.data.FASE_causali
                : new Array();

              this.items_tipo_causali = res.data.TIPO_CAUSALE_FERMO
                ? res.data.TIPO_CAUSALE_FERMO
                : new Array();
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare alcuni dati relativi alle causali di fermo."
          );

          return false;
        });
    },
    getTempi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdatitempi",
          token: localStorage.user_token,
          start: this.tempi_data_da,
          stop: this.tempi_data_a,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_tempi_selezionabili = res.data.result.tempi;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getVincoliModifica() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "CONSUNTIVI_FERMI",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni per questo modulo, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              ).length > 0
            ) {
              this.limite_mesi_passati = res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaRettifica() {
      const obj_tmp = new Riga(this.riga_sel);

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: [obj_tmp],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.rettifica_dialog = false;
            this.riga_sel = new Riga();

            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Rettifica eseguita con successo."
            );

            // Aggiorno i dati
            this.getCommessaCausali();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaRigaFermi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: [
            {
              minuti: this.minuti_tmp,
              id_commessa: this.id_commessa_tmp,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              id_commessa_tempi: this.id_commessa_tempi_tmp,
              id_causale: this.id_causale_tmp,
              tipo: this.tipo_tmp,
              tipo_causale: "FERMO",
              validita: 1,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_aggiungi_pezzi = false;
            this.quantita_tmp = null;
            this.qta_box_tmp = null;
            this.qta_pz_tmp = null;
            this.id_commessa_tmp = null;
            this.cod_commessa_tmp = "";
            this.id_commessa_dettaglio_tmp = null;
            this.cod_fase_tmp = "";
            this.id_commessa_tempi_tmp = null;
            this.id_macchina_tmp = null;
            this.cod_macchina_tmp = "";
            this.id_personale_tmp = "";
            this.nominativo_tmp = "";

            this.dialog_aggiungi_fermi = false;
            this.getCommessaCausali();

            this.$refs.SnackbarQV.print(
              "success",
              "Produzione registrata con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    selezionaTempo(arg) {
      this.id_commessa_tmp = arg.id_commessa;
      this.cod_commessa_tmp = arg.cod_commessa;
      this.start_tmp = arg.ora_inizio;
      this.stop_tmp = arg.ora_fine;
      this.id_commessa_dettaglio_tmp = arg.id_commessa_dettaglio;
      this.cod_fase_tmp = arg.cod_fase;

      this.dialog_seleziona_tempi = false;
      this.items_tempi_selezionabili = new Array();
    },
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          this.data_a = moment().format("YYYY-MM-DD");
          this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");

          await this.getTabella();
          this.getCommessaCausali();
        }
      },
    },
  },
  mounted() {
    this.tempi_data_a = moment().format("YYYY-MM-DD");
    this.tempi_data_da = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.getVincoliModifica();
  },
};
</script>
<style>
</style>